import { RequestItemsSchema, SignableDocumentSchema } from '@liscio/api';

export const getSignedDocumentsFromItems = (items: RequestItemsSchema[]) => {
  const signableDocumentItems = items.filter(
    (item) => item.item_type === 'signable_document'
  );
  return signableDocumentItems
    .map(
      (item) =>
        (item.dependency?.object as SignableDocumentSchema).signed_document
    )
    .filter((signedDocument) => signedDocument !== null);
};
